import React, { useCallback, useId } from "react";
import { useLinkClickHandler } from "react-router";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import Linkbar from "@coworker/apprestructured/src/shared/components/Linkbar/Linkbar";
import { useAllTaskTypes } from "@coworker/apprestructured/src/task-management/services/useTaskTypes";
import LinkbarLoading from "@coworker/apprestructured/src/shared/components/Linkbar/LinkbarLoading";
import { useTranslation } from "@coworker/locales";

function TaskTypeListViewItem({ id, label }: { id: string; label: string }) {
  const href = `/tasks/new?taskCreator=${id}`;

  const { t } = useTranslation();

  const linkClickHandler = useLinkClickHandler(href);

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
      linkClickHandler(e as React.MouseEvent<HTMLAnchorElement>);
    },
    [linkClickHandler]
  );

  return (
    <FixaListViewItem
      control="link"
      href={href}
      controlIcon={null}
      onClick={handleClick}
      inset
      title={t(label)}
    />
  );
}

function TaskTypesPage() {
  const id = useId();

  const { data: taskTypes } = useAllTaskTypes();

  const { t } = useTranslation();

  if (!taskTypes) {
    return <LinkbarLoading />;
  }

  return (
    <>
      <Linkbar currentLabel="New task" currentAsH1 />
      <FixaListView id={id}>
        {taskTypes.map(({ id, label }) => (
          <TaskTypeListViewItem key={id} id={`${id}`} label={t(label)} />
        ))}
      </FixaListView>
    </>
  );
}

export default TaskTypesPage;
